<table
  aria-label="Storage file list"
  id="storageFileList"
  class="table table--hover table--selector"
  [ngClass]="
    storageService.isMultipleSelector(storageFull, selectorType)
      ? 'table--multiple-selector'
      : 'table--single-selector'
  "
  [shown]="
    filesDetails.code !== 202 && filesDetails.code !== 404 && fileListVisible
  "
>
  <thead class="table-header">
    <tr class="table-header__row u_clickable">
      <th
        class="col-sm-6 table-header__cell"
        [attr.aria-sort]="
          search.sortBy === 'name'
            ? search.reverse
              ? 'descending'
              : 'ascending'
            : null
        "
      >
        <div class="flex-row">
          <mat-checkbox
            class="tw-pr-[16px]"
            (click)="$event.stopPropagation()"
            (change)="selectAll.emit()"
            [(ngModel)]="isAllSelected"
            [shown]="
              storageService.isMultipleSelector(storageFull, selectorType)
            "
            matTooltip="Bulk select"
            matTooltipShowDelay="500"
            matTooltipClass="menu-tooltip"
            aria-label="Select all"
          />
          <div id="tableHeaderName" (click)="changeSort('name')">
            Name
            @if (search.sortBy === 'name') {
              <i
                [attr.aria-label]="
                  search.reverse ? 'Descending order' : 'Ascending order'
                "
                class="fa"
                [ngClass]="search.reverse ? 'fa-caret-down' : 'fa-caret-up'"
              ></i>
            }
          </div>
        </div>
      </th>
      @if (!storageService.isFolderFilter(selectorFilter)) {
        <th
          class="col-sm-2 table-header__cell hidden-xs"
          tabindex="0"
          (keyup.enter)="changeSort('extension')"
          (click)="changeSort('extension')"
        >
          Type
          @if (search.sortBy === 'extension') {
            <i
              [attr.aria-label]="
                search.reverse ? 'Descending order' : 'Ascending order'
              "
              class="fa"
              [ngClass]="search.reverse ? 'fa-caret-down' : 'fa-caret-up'"
            ></i>
          }
        </th>
        <th
          class="col-sm-2 table-header__cell visible-lg"
          tabindex="0"
          (keyup.enter)="changeSort('size')"
          (click)="changeSort('size')"
        >
          Size
          @if (search.sortBy === 'size') {
            <i
              [attr.aria-label]="
                search.reverse ? 'Descending order' : 'Ascending order'
              "
              class="fa"
              [ngClass]="search.reverse ? 'fa-caret-down' : 'fa-caret-up'"
            ></i>
          }
        </th>
        <th
          class="col-sm-2 table-header__cell visible-lg"
          tabindex="0"
          (keyup.enter)="changeSort('dateModified')"
          (click)="changeSort('dateModified')"
        >
          Modified
          @if (search.sortBy === 'dateModified') {
            <i
              [attr.aria-label]="
                search.reverse ? 'Descending order' : 'Ascending order'
              "
              class="fa"
              [ngClass]="search.reverse ? 'fa-caret-down' : 'fa-caret-up'"
            ></i>
          }
        </th>
        <th class="table-header__cell action-column"></th>
      }
    </tr>
  </thead>
  <tbody class="table-body">
    <tr
      *cdkVirtualFor="let file of foldersAndFiles; let i = index"
      class="table-body__row clickable"
      [rvDraggableItem]="file.item"
      [dragNotAllowed]="
        !storageFull ||
        isTrashFolder ||
        !storageService.canSelect(
          file,
          storageFull,
          selectorType,
          selectorFilter
        )
      "
      [rvDroppableItem]="file.item"
      [dropNotAllowed]="!storageUtilsService.fileIsFolder(file.item)"
      [class.active]="file.selected"
      [class.table-body__row--blocked-file]="file.item.isThrottled"
      [class.table-body__row--no-select]="
        !storageService.canSelect(
          file,
          storageFull,
          selectorType,
          selectorFilter
        )
      "
      [class.table-body__row--disabled]="
        storageService.isDisabled(
          file,
          storageFull,
          selectorType,
          selectorFilter
        )
      "
      (click)="fileClick.emit(file)"
    >
      @if (storageUtilsService.fileIsFolder(file.item)) {
        <td class="table-body__cell draggable-mirror-content">
          <div
            class="flex-row"
            [class.no-padding-left]="
              !storageService.canSelect(
                file,
                storageFull,
                selectorType,
                selectorFilter
              )
            "
          >
            @if (
              storageService.canSelect(
                file,
                storageFull,
                selectorType,
                selectorFilter
              )
            ) {
              <mat-checkbox
                class="tw-pr-[8px] mr-0 draggable-mirror-content-hidden"
                (click)="$event.stopPropagation()"
                (change)="fileSelect.emit(file)"
                [checked]="file.selected"
                matTooltip="Bulk select"
                matTooltipShowDelay="500"
                matTooltipClass="menu-tooltip"
                aria-labelledby="file-name-{{ i }}"
              />
            }
            <thumbnail-image
              [small]="true"
              [file]="file"
              [folderPath]="folderPath"
              [index]="i"
              [selectorType]="selectorType"
              [selectorFilter]="selectorFilter"
              [storageFull]="storageFull"
            />
            <span
              id="file-name-{{ i }}"
              class="u_ellipsis-lg folder tw-font-medium tw-ml-4"
              title="{{ file.item.name | storageFileName }}"
              >{{ file.item.name | storageFileName: folderPath }}</span
            >
          </div>
        </td>
      } @else {
        <td class="col-sm-6 table-body__cell draggable-mirror-content">
          <div class="tw-flex tw-flex-row tw-items-center">
            @if (
              storageService.canSelect(
                file,
                storageFull,
                selectorType,
                selectorFilter
              )
            ) {
              <mat-checkbox
                class="tw-pr-[8px] tw-mr-0 draggable-mirror-content-hidden"
                [aria-labelledby]="'file-name-' + i"
                [checked]="file.selected"
                matTooltip="Bulk select"
                matTooltipShowDelay="500"
                matTooltipClass="menu-tooltip"
              />
            }
            <thumbnail-image
              [small]="true"
              [file]="file"
              [folderPath]="folderPath"
              [selectorType]="selectorType"
              [selectorFilter]="selectorFilter"
              [storageFull]="storageFull"
            />
            <span
              id="file-name-{{ i }}"
              class="file u_ellipsis-lg tw-ml-[10px]"
              title="{{ file.item.name | storageFileName }}"
            >
              <i
                aria-label="File is throttled"
                class="fa fa-exclamation u_icon-red"
                [shown]="
                  file.item.isThrottled &&
                  !storageUtilsService.fileIsFolder(file.item)
                "
              ></i>
              <span class="tw-font-medium">{{
                file.item.name | storageFileName: folderPath
              }}</span>
            </span>
          </div>
          <div
            [shown]="
              file.item.showThrottledCallout &&
              !storageUtilsService.fileIsFolder(file.item)
            "
            class="callout callout-red draggable-mirror-content-hidden"
            (click)="
              $event.stopPropagation(); file.item.showThrottledCallout = false
            "
          >
            <span class="arrow"></span>
            <p>This file is being requested too many times and is blocked.</p>
            <p>
              If you need assistance please click the
              <strong>Need Help?</strong> menu item above.
            </p>
          </div>
        </td>
      }
      <!-- @if (!storageService.isFolderFilter(selectorFilter)) { -->
      <td class="col-sm-2 table-body__cell hidden-xs">
        <span class="tw-text-gray-500">
          {{ file.item.name | storageFileType }}</span
        >
      </td>
      <td class="col-sm-2 table-body__cell visible-lg tw-text-gray-500">
        <span> {{ file.item.size | storageFileSize }}</span>
      </td>
      <td class="col-sm-2 table-body__cell tw-text-gray-500 visible-lg">
        <change-details
          [changeDate]="file.item.updated?.value"
        ></change-details>
      </td>
      <td class="table-body__cell action-column">
        @if (!storageUtilsService.fileIsTrash(file.item)) {
          <operations-menu
            id="file-operations-menu-{{ i + 1 }}"
            (operationClick)="
              operationClick.emit({ file, operationName: $event })
            "
            [operations]="listOperations"
          />
        }
      </td>
      <!-- } -->
    </tr>
    @if (isEmpty) {
      <tr class="placeholder">
        <td colspan="6">
          <empty-state
            [search]="search"
            [isMultipleFilesFoldersSelector]="
              storageService.isMultipleFilesFoldersSelector(selectorType)
            "
            (uploadFiles)="uploadFiles.emit()"
          />
        </td>
      </tr>
    }
  </tbody>
</table>
